export default class AbortError extends Error {
	constructor() {
		super('Request was aborted');
	}
}
